module.exports = __webpack_public_path__ + "static/media/moraine-45.8cc4be89.jpg";